(() => {
  if (customElements.get('grid-feature-swiper')) {
    return;
  }

  class GridFeatureSwiper extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      this.options = {
        slidesPerView: 2.2,
        slidesPerGroup: 2,
        spaceBetween: 5,
        loop: false,
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          clickable: true
        }
      };

      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options,
      );
    }
  }

  customElements.define('grid-feature-swiper', GridFeatureSwiper);
})();